export const Annual_Report_Year_List = {
    'ar-agm-2017-18': {
        Meta_title: 'AR/AGM 2017-18 | Marvel Blinds',
        OG_title: 'AR/AGM 2017-18',
        Meta_Description: 'Extract of Annual Return_2017-18 Form MGT-7 of FY 2017-18 Annual Report 2017-18 Notice of AGM Attendance Slip of AGM AGM Proceedings Voting Results Scrutinizer’s Report',
        OG_Description: 'Extract of Annual Return_2017-18 Form MGT-7 of FY 2017-18 Annual Report 2017-18 Notice of AGM Attendance Slip of AGM AGM Proceedings Voting Results Scrutinizer’s Report',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/annual-report/ar-agm-2017-18/`,

        PG_title: 'AR/AGM 2017-18',
        data: [
            { title: 'Extract of Annual Return_2017-18', url: '/Documnets/Extract_of_Annual_Return_2017-18.pdf' },
            { title: 'Form MGT-7 of FY 2017-18', url: '/Documnets/Form_MGT-7_FY_2017-18.pdf' },
            { title: 'Annual Report 2017-18', url: '/Documnets/Marvel-Decor-Ltd.-Annual-Report-2017-18-1.pdf' },
            { title: 'Notice of AGM', url: '/Documnets/Notice-of-AGM-1.pdf' },
            { title: 'Attendance Slip of AGM', url: '/Documnets/Attendance-Slip-AGM.pdf' },
            { title: 'AGM Proceedings', url: '/Documnets/AGM_proceeding.pdf' },
            { title: 'Voting Results', url: '/Documnets/voting_result.pdf' },
            { title: 'Scrutinizer’s Report', url: '/Documnets/scrutinizer_report_AR.pdf' }
        ]
    },
    'ar-agm-2018-19': {
        Meta_title: 'AR/AGM 2018-19 | Marvel Blinds',
        OG_title: 'AR/AGM 2018-19',
        Meta_Description: 'Extract of Annual Return_2018-19 Form MGT-7 of FY 2018-19 Annual Report 2018-19 Notice of AGM Attendance Slip of AGM AGM Proceedings Voting Results Scrutinizer’s Report',
        OG_Description: 'Extract of Annual Return_2018-19 Form MGT-7 of FY 2018-19 Annual Report 2018-19 Notice of AGM Attendance Slip of AGM AGM Proceedings Voting Results Scrutinizer’s Report',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/annual-report/ar-agm-2018-19/`,

        PG_title: 'AR/AGM 2018-19',
        data: [
            { title: 'Extract of Annual Return_2018-19', url: '/Documnets/Extract_of_Annual_Return_2018-19.pdf' },
            { title: 'Form MGT-7 of FY 2018-19', url: '/Documnets/Form_MGT-7_of_FY_2018-19.pdf' },
            { title: 'Annual Report 2018-19', url: '/Documnets/marvel_annual_report.pdf' },
            { title: 'Notice of AGM', url: '/Documnets/notice_for_agm_18_19.pdf' },
            { title: 'Attendance Slip of AGM', url: '/Documnets/attendance_slip_for_agm_18-19.pdf' },
            { title: 'AGM Proceedings', url: '/Documnets/proceedings_agm_2018_19_marvel.pdf' },
            { title: 'Voting Results', url: '/Documnets/voting_results_agm_30092019_marvel.pdf' },
            { title: 'Scrutinizer’s Report', url: '/Documnets/scrutinizer_report_agm_30092019_marvel.pdf' }
        ]
    },
    'ar-agm-2019-20': {
        Meta_title: 'AR/AGM 2019-20 | Marvel Blinds',
        OG_title: 'AR/AGM 2019-20',
        Meta_Description: 'Extract of Annual Return_2019-20 Annual Report 2019-20 Form MGT-7 of FY 2019-20 C.S. Scrutinizer’s Report AGM Voting Result AGM Proceeding AGM Newspaper_Gujarati AGM Newspaper_English AGM of Marvel Decor Ltd 2019-20',
        OG_Description: 'Extract of Annual Return_2019-20 Annual Report 2019-20 Form MGT-7 of FY 2019-20 C.S. Scrutinizer’s Report AGM Voting Result AGM Proceeding AGM Newspaper_Gujarati AGM Newspaper_English AGM of Marvel Decor Ltd 2019-20',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/annual-report/ar-agm-2019-20/`,

        PG_title: 'AR/AGM 2019-20',
        data: [
            { title: 'Extract of Annual Return_2019-20', url: '/Documnets/Extract_of_Annual_Return_2019-20.pdf' },
            { title: 'Annual Report 2019-20', url: '/Documnets/marvel_annual_report-20.pdf' },
            { title: 'Form MGT-7 of FY 2019-20', url: '/Documnets/Form_MGT-7FY2019-20.pdf' },
            { title: 'C.S. Scrutinizer’s Report', url: "/Documnets/c.s._scrutinizer's_report.pdf" },
            { title: 'AGM Voting Result', url: '/Documnets/agm_voting_result.pdf' },
            { title: 'AGM Proceeding', url: '/Documnets/agm_proceeding1920.pdf' },
            { title: 'AGM Newspaper_Gujarati', url: '/Documnets/agm_newspaper_gujarati.pdf' },
            { title: 'AGM Newspaper_English', url: '/Documnets/agm_newspaper_english.pdf' },
            { title: 'AGM of Marvel Decor Ltd 2019-20', url: 'https://youtu.be/B9METzlcSwY?si=PSsJ1Z7unBFa47Kv' }
        ]
    },
    'ar-agm-2020-21': {
        Meta_title: 'AR/AGM 2020-21 | Marvel Blinds',
        OG_title: 'AR/AGM 2020-21',
        Meta_Description: 'Extract of Annual Return_2020-21 Form MGT-7 of FY 2020-21 AR/AGM 2020-21 Attendance Slip AGM – Notice 2021 MGT – 9',
        OG_Description: 'Extract of Annual Return_2020-21 Form MGT-7 of FY 2020-21 AR/AGM 2020-21 Attendance Slip AGM – Notice 2021 MGT – 9',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/annual-report/ar-agm-2020-21`,

        PG_title: 'AR/AGM 2020-21',
        data: [
            { title: 'Extract of Annual Return_2020-21', url: '/Documnets/Extract_of_Annual_Return_2020-21.pdf' },
            { title: 'Form MGT-7 of FY 2020-21', url: '/Documnets/Form_MGT-7FY2020-21.pdf' },
            { title: 'AR/AGM 2020-21', url: '/Documnets/ar-agm-2020-21.pdf' },
            { title: 'Attendance Slip', url: '/Documnets/ar-agm-2020-21.pdf' },
            { title: 'AGM – Notice 2021', url: '/Documnets/agm_notice-2021.pdf' },
            { title: 'MGT – 9', url: '/Documnets/mgt-9.pdf' },
        ]
    },
    'ar-agm-2021-22': {

        Meta_title: 'AR/AGM 2021-22 | Marvel Blinds',
        OG_title: 'AR/AGM 2021-22',
        Meta_Description: 'Extract of Annual Return_2021-22 Form MGT-7 of FY 2021-22 AR/AGM 2021-22 Attendance Slip AGM – Notice 2022',
        OG_Description: 'Extract of Annual Return_2021-22 Form MGT-7 of FY 2021-22 AR/AGM 2021-22 Attendance Slip AGM – Notice 2022',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/annual-report/ar-agm-2021-22`,

        PG_title: 'AR/AGM 2021-22',
        data: [
            { title: 'Extract of Annual Return_2021-22', url: '/Documnets/Extract_of_Annual_Return_2021-22.pdf' },
            { title: 'Form MGT-7 of FY 2021-22', url: '/Documnets/Form_MGT-7FY2021-22.pdf' },
            { title: 'AR/AGM 2021-22', url: '/Documnets/ar-agm-2021-22.pdf' },
            { title: 'Attendance Slip', url: '/Documnets/AttendanceSlip2122.pdf' },
            { title: 'AGM – Notice 2022', url: '/Documnets/NoticeAGM-2022.pdf' },
        ]
    },
    'ar-agm-2022-23': {
        Meta_title: 'AR/AGM 2022-23 | Marvel Blinds',
        OG_title: 'AR/AGM 2022-23',
        Meta_Description: 'Extract of Annual Return_2022-23 Form MGT-7 of FY 2022-23 AR/AGM 2022-23 Attendance Slip AGM – Notice 2023',
        OG_Description: 'Extract of Annual Return_2022-23 Form MGT-7 of FY 2022-23 AR/AGM 2022-23 Attendance Slip AGM – Notice 2023',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/annual-report/ar-agm-2022-23`,

        PG_title: 'AR/AGM 2022-23',
        data: [
            { title: 'Extract of Annual Return_2022-23', url: '/Documnets/Extract-of-Annual-Return_2022-23.pdf' },
            { title: 'Form MGT-7 of FY 2022-23', url: '/Documnets/Form_MGT-7_for_FY_2022-23.pdf' },
            { title: 'AR/AGM 2022-23', url: '/Documnets/Marvel-Annual-Report-2022-2023-final-05-09-2023.pdf' },
            { title: 'Attendance Slip', url: '/Documnets/AttendanceSlip_230905_170322.pdf' },
            { title: 'AGM – Notice 2023', url: '/annual-report/ar-agm-2023-24' },
        ]
    },
    'ar-agm-2023-24': {
        Meta_title: 'AR/AGM 2023-24 | Marvel Blinds',
        OG_title: 'AR/AGM 2023-24',
        Meta_Description: 'AR/AGM 2023-24 Attendance Slip Form MGT-7 for FY 2023-24 AGM – Notice 2024',
        OG_Description: 'AR/AGM 2023-24 Attendance Slip Form MGT-7 for FY 2023-24 AGM – Notice 2024',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/annual-report/ar-agm-2023-24`,

        PG_title: 'AR/AGM 2023-24   ',
        data: [
            { title: 'AR/AGM 2023-24', url: '/Documnets/' },
            { title: 'Attendance Slip', url: '/Documnets/Attendance_Slip2425.pdf' },
            { title: 'Form MGT-7 for FY 2023-24', url: '/Documnets/Form_MGT_7-MDL-2023-24_SS.pdf' },
            { title: 'AGM – Notice 2024', url: '/Documnets/AGM_Notice-2024.pdf' },
        ]
    },
        'ar-agm-2025-26': {
        Meta_title: 'AR/AGM 2025-26 | Marvel Blinds',
        OG_title: 'AR/AGM 2025-26',
        Meta_Description: 'Extract of Annual Return_2025-26 Annual Report 2025-26 Form MGT-7 of FY 2025-26 Notice of AGM Attendance Slip of AGM AGM Proceedings Voting Results Scrutinizer’s Report',
        OG_Description: 'Extract of Annual Return_2025-26 Annual Report 2025-26 Form MGT-7 of FY 2025-26 Notice of AGM Attendance Slip of AGM AGM Proceedings Voting Results Scrutinizer’s Report',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/annual-report/ar-agm-2025-26`,

        PG_title: 'AR/AGM 2025-26',
        data: [
            { title: 'Notice of AGM', url: '/Documnets/Notice_of_AGM_2025-26.pdf' },
            { title: 'AnnualReport 2025-2026', url: '/Documnets/final.pdf' },
            { title: 'Attendance Slip', url: '/Documnets/Attendance_Slip_2025-26.pdf' },
            { title: 'Proxy Form', url: '/Documnets/Proxy_Form_2025-26.pdf' },
            { title: 'Corrigendum', url: '/Documnets/Corrigendum.pdf' },
            { title: 'Corrigendum2', url: '/Documnets/Corrigendum2.pdf' },
        ]
    },
}